import { render, staticRenderFns } from "./data9.vue?vue&type=template&id=00d66cc8&scoped=true&"
import script from "./data9.vue?vue&type=script&lang=js&"
export * from "./data9.vue?vue&type=script&lang=js&"
import style1 from "./data9.vue?vue&type=style&index=1&id=00d66cc8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d66cc8",
  null
  
)

export default component.exports